function getToJsonSchemaFn() {
  return (schema) => JSON.parse(JSON.stringify(schema.Type()));
}

export { getToJsonSchemaFn as default };
